import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {WsChatMessage} from "../types/message";

interface ChatState {
  messages: WsChatMessage[];
}

const initialState: ChatState = {
  messages: [],
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<any>) => {
      state.messages.push(action.payload);
      const uniqueMessages = new Map(
          state.messages.map((message) => [message.message_id, message])
      );

      state.messages = Array.from(uniqueMessages.values()).sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateA - dateB;
      });
    },
    clearMessages: (state) => {
      state.messages = [];
    },
    deleteMessage: (state, action: PayloadAction<number>) => {
      state.messages = state.messages.filter(
          (message) => (
              message.message_id !== action.payload
          )
      );
    }
  },
});

export const {addMessage, clearMessages, deleteMessage} = chatSlice.actions;

export default chatSlice.reducer;
